import { useState } from "react";
import { Handler } from "../common/handler";
import Stave from "../common/extension/MusiconStave";
import PlayCircle from "../assets/icons/play-circle-fill.svg"
import StopCircle from "../assets/icons/stop-circle-fill.svg"

interface PlayButtonProps {
  handler: Handler | null;
}

export const PlayButton = ({ handler }: PlayButtonProps) => {
  const [img, setImg] = useState(PlayCircle);

  const canPlay = (handler: Handler | null): boolean => {
    const isEmpty =
      handler?.getStaveList().filter((stave: Stave) => {
        return stave.getTickables().length > 0;
      }).length == 0;

    return !(handler == null || isEmpty);
  };

  return (
    <div className="play-button-container">
      <img
        className="play-button"
        onClick={() => {
          // 如果乐谱为空，不做任何动作
          if (!canPlay(handler)) return;

          if (handler?.playing === true) {
            handler?.stop();
            setImg(PlayCircle);
          } else {
            handler?.play(() => {
              setImg(PlayCircle);
            });
            setImg(StopCircle);
          }
        }}
        src={img}
      />
    </div>
  );
};
